import React from "react";
import { sumBy, filter } from "lodash";

import { moneyFormat } from "./format";
import OnePanelChart from "./OnePanelChart";
import Text from "./Text";
import FormulaTable from "./FormulaTable";
import { pickMillions, getTeam } from "./utils";
import Auth from "routes/Auth";

const Valuation1 = ({
  teams,
  competitiveAnalysis,
  competitiveAnalysisAll,
  competitionMetrics,
  teamId,
  comparableCompanies,
  constants,
  round
}) => {
  const data =
    Auth.getPosition() === "Student" ? competitiveAnalysis : competitionMetrics;
  const field =
    Auth.getPosition() === "Student" ? "Market Capitalization" : "Market Value";
  const team = getTeam(teamId, data);
  const marketCap = moneyFormat(team[field]);
  const teamRounds = filter(
    competitiveAnalysisAll,
    item => item.team === teamId
  );
  const obj1 = teamRounds.find(i => i.Round === round);
  const netRevenues = obj1 && "Net Revenues" in obj1 ? obj1["Net Revenues"] : 0;
  const psMultiples =
    sumBy(comparableCompanies, "price_to_sales") / comparableCompanies.length;
  const marketCapCalculated = netRevenues * psMultiples;
  const minValuation = constants["min_valuation"];

  return (
    <OnePanelChart
      title="Valuation"
      prefix="$"
      suffix="M"
      data={pickMillions(teams, data, field)}
      teams={teams}
    >
      <Text>
        In this round, equity investors use the Price to Sales Multiples (P/S)
        valuation method to value your business at {marketCap}.<br />
        <br />
        P/S valuation method takes your net revenues and multiply that by the
        P/S multiple of a comparable company. Here’s the breakdown:
      </Text>
      <FormulaTable
        items={[
          {
            name: "Team Valuation",
            highlighted: true,
            value: moneyFormat(marketCapCalculated)
          },
          { name: "=", highlighted: false, value: "" },
          {
            name: "Net Revenues",
            highlighted: true,
            value: moneyFormat(netRevenues)
          },
          { name: "×", highlighted: false, value: "" },
          {
            name: "P/S multiples",
            highlighted: true,
            value: psMultiples.toFixed(2)
          }
        ]}
      />
      {marketCapCalculated < minValuation && (
        <Text style={{ marginTop: "1.5em" }}>
          Investors place a minimum value of {moneyFormat(minValuation)} to your
          business.
        </Text>
      )}
    </OnePanelChart>
  );
};

export default Valuation1;



// WEBPACK FOOTER //
// ./src/components/analysis/Valuation1.js